import { MonthCV } from '../model/cv/MonthCV.model';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { DateUtil } from './DateUtil.model';
import { SSIMUtils } from './SSIMUtil';

export class SSIMDateUtils {

  public static SSIM_LEAPYEAR_DATE = '29FEB';

    public static getSSIMFromIncompleteString(value: string, translateService: TranslateService): string {
      if (value) {
        const months: MonthCV = new MonthCV(translateService);
        if (value.length >= 3 && value.length <= 5) {
          const day = Number(value.substr(0, 2));
          for (const month of (months.list)) {
            if (month.short.substr(0, value.length - 2).toLowerCase() === value.substr(2).toLowerCase()) {
              if (month.maxDay >= day) {
                return `${(day < 10 ? '0' : '')}${day}${month.short as string}`;
              }
            }
          }
        }
        return null;
      }
    }

    public static getStringDateFromSSIMString(
      value: string,
      translate: TranslateService,
      isBeginDay = false,
      isEndDay = false,
      fromDateIntervalReferencial?: Date,
      toDateIntervalReferencial?: Date): string {

      if (value === null || value === '') {
        return null;
      }

      const dateComplete: Date = this.getDatetimeFromSSIMString(value, translate, isBeginDay, isEndDay, fromDateIntervalReferencial, toDateIntervalReferencial);

      const datePipe = new DatePipe('en_EN');
      const dateFormat = 'yyyy-MM-dd';
      if (dateComplete) {
        return datePipe.transform(dateComplete, dateFormat, 'UTC');
      } else {
        return '';
      }
    }

    public static getDatetimeFromSSIMString(
        value: string,
        translate: TranslateService,
        isBeginDay = false,
        isEndDay = false,
        fromDateIntervalReferencial?: Date,
        toDateIntervalReferencial?: Date): Date {
      const ssim: string = this.getSSIMFromIncompleteString(value, translate);
      if (ssim) {
        let date: Date = this.getDatetimeFromSSIMFormat(ssim, translate, isBeginDay, isEndDay, toDateIntervalReferencial ?toDateIntervalReferencial : null );
        if (fromDateIntervalReferencial && toDateIntervalReferencial) {
            date = this.getDatetimeWhithYearChangeWithDateIntervalReference(date, fromDateIntervalReferencial, toDateIntervalReferencial);
        }
        return date;
      } else {
        return null;
      }
    }

    public static getDatetimeFromSSIMFormat(dateString: string, translate: TranslateService, isBeginDay = false, isEndDay = false, dateReference: Date): Date {
        if (!dateString || dateString === '') { return null; }
        // const dateStringSplit = dateString.split('-');
        // if (dateStringSplit.length !== 2) { throw new Error('Parameter is not a SSIM format'); }
        const day = dateString.substring(0, 2);
        const monthString = dateString.substring(2);
        if (monthString.length !== 3) { throw new Error('Parameter is not a SSIM format'); }
        const monthNumber = this.getMonthNumberFromShort(monthString, translate);
        const year = (dateReference ? dateReference : new Date()).getUTCFullYear();
        let time = DateUtil.getNowTime();
        if (isBeginDay) {
          time = '00:00:00';
        } else if (isEndDay) {
          time = '23:59:00';
        }
        const completeDay = `${year}-${monthNumber}-${day} ${time}`;
        const date: Date = new Date(completeDay);
        return DateUtil.getDateFromUTCDate(date);
    }

    public static getDatetimeWhithYearChangeWithDateIntervalReference(date: Date, startDatetimeReference: Date, endDatetimeReference: Date): Date {
        if (!startDatetimeReference || !endDatetimeReference || !date) {
            return null;
        }
        if (startDatetimeReference.getUTCFullYear() === endDatetimeReference.getUTCFullYear()) {
            // Summer Season
            date.setUTCFullYear(startDatetimeReference.getUTCFullYear());
        } else {
            // Winter Season
            if (date.getUTCMonth() <= endDatetimeReference.getUTCMonth()) {
                // console.log('Seleccionado anyo de fin de Temporada' + this.actualSeason.endDatetime.getUTCFullYear());
                date.setUTCFullYear(endDatetimeReference.getUTCFullYear());
            } else {
                //  console.log('Seleccionado anyo del inicio de Temporada' + this.actualSeason.startDatetime.getUTCFullYear());
                date.setUTCFullYear(startDatetimeReference.getUTCFullYear());
            }
        }
        return date;
    }

    public static getSSIMFormatFromDateWithoutUTC(date: Date): string {
      const datePipe = new DatePipe('en_EN');
      const dateFormat = 'ddMMM';
      if (date) {
        const dateFormatString: string = datePipe.transform(date, dateFormat);
        // dateFormatString = dateFormatString.substring(0, dateFormatString.length - 1);
        return dateFormatString.toUpperCase();
      } else {
        return '';
      }
    }

    public static getSSIMFormatFromDate(date: Date): string {
        const datePipe = new DatePipe('en_EN');
        const dateFormat = 'ddMMM';
        if (date) {
          const dateFormatString: string = datePipe.transform(date, dateFormat, 'UTC');
          // dateFormatString = dateFormatString.substring(0, dateFormatString.length - 1);
          return dateFormatString.toUpperCase();
        } else {
          return '';
        }
    }

    public static getSSIMFormatFromStringDate(dateString: string): string {
      const datePipe = new DatePipe('en_EN');
      const dateFormat = 'ddMMM';
      if (dateString) {
        const dateFormatString: string = datePipe.transform(dateString, dateFormat);
        // dateFormatString = dateFormatString.substring(0, dateFormatString.length - 1);
        return dateFormatString.toUpperCase();
      } else {
        return '';
      }
    }

    public static getSSIMFormatFromTime(date: Date): string {
        const datePipe = new DatePipe(navigator.language);
        const dateFormat = 'HH:mm';
        if (date) {
          return datePipe.transform(date, dateFormat, 'UTC');
        } else {
          return '';
        }
    }

    // Método que comprueba si un año es bisiesto
    public static isLeapYear(year: number): boolean {
      const fullDate = new Date(year.toString() + '-02-29T00:00:00.000+0000');
      if (fullDate.getUTCMonth() === 1) {
        return true;
      }
      return false;
    }

    private static getMonthNumberFromShort(short: string, translate: TranslateService): string {
      const months: MonthCV = new MonthCV(translate);

      for (const month of (months.list)) {
        if (month.short === short) {
          return month.dayNumber as string;
        }
      }
    }

  // Cuando se abandona los días de operación, si se deja vacío y es el mismo día el desde y el hasta, lo autocompleta -----------------------------------------------------------------
  public static getOperationDays(date: Date): string {
    let dayOfDate: number = date.getDay();
    if (dayOfDate === 0) { dayOfDate = 7; }
    const operationDays: string = SSIMUtils.getSSIMOperationDaysFromNumberDay(dayOfDate);
    return operationDays;
  }

  public static getOperationDaysFromTo(dateFrom: Date, dateTo: Date): string {
    let final: string = '';
    let dateAux = new Date(dateFrom);

    while (dateAux <= dateTo) {
      let dayOfDate: number = dateAux.getDay();
      if (dayOfDate === 0) { dayOfDate = 7; }
      if (final.indexOf(dayOfDate.toString()) === -1) {
        final = `${final}${dayOfDate}`;
      }
      dateAux.setDate(dateAux.getDate() + 1);
    }
    return SSIMUtils.getSSIMOperationDaysFromInputString(final);
  }

}
